interface V3IconFilterProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconFilter = ({ stroke = "#ABB0BA" }: V3IconFilterProps) => <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.8 6.5h6.4M3.2 3.5h9.6M6.398 9.5h3.2M7.2 12.5h1.6" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>
